<template>
    <div>
        <div class="card">
            <div class="card-header">Work within Minnesota Dates</div>
            <div class="card-body" v-if="!!workDatesApplication">
                <b-row>
                    <b-col>
                        Starting and anticipated completion dates of work in Minnesota.
                    </b-col>
                </b-row>

                <div role="alert">
                    <b-row v-if="workDatesApplication.mnSupervisor.length > 0">
                        <b-col>
                            <div class="text-danger" v-if="!this.validateDates(workDatesApplication.mnSupervisor, this.workDatesApplication)">
                                Work Dates cannot exceed 30 days.
                                If you need licensure for more then 30 days, please apply for a Temporary or Full license.</div>
                        </b-col>
                    </b-row>
                    <b-row v-if="workDatesApplication.mnSupervisor.length > 0">
                        <b-col>
                            <div class="text-danger" v-if="!this.validateYear(workDatesApplication.mnSupervisor)">Work Dates must all be in the same calendar year.
                                Applications for the next calendar year may be submitted after November 1st.</div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <div class="text-danger" v-if="opts.minLengthError">
                            Cannot submit a Work Date change request with no changes to existing work dates.
                        </div>
                    </b-row>
                </div>

                <b-row class="mt-3">
                    <b-col>
                        <b-button variant="btn btn-outline-primary" size="sm" @click="addWorkPeriod">
                            Add Another Work Period
                        </b-button>
                    </b-col>
                </b-row>

                <div v-for="(supervisor, index) in workDatesApplication.mnSupervisor" :key="supervisor.id">
                    <b-row class="mt-2">
                        <b-col cols="12" lg="3">
                            <BaseDateInput v-model="supervisor.workDate.startDate"
                                           :v="$v.workDatesApplication.mnSupervisor.$each[index].workDate.startDate"
                                           slug="startDate"
                                           label="Start Date"
                                           :key="index"
                                           :setId="'startDate'+index"
                                           :messages="opts.startDateMessages"
                                           :disabled="supervisor.id != null"
                            />
                        </b-col>
                        <b-col cols="12" lg="3">
                            <BaseDateInput v-model="supervisor.workDate.endDate"
                                           :v="$v.workDatesApplication.mnSupervisor.$each[index].workDate.endDate"
                                           slug="endDate"
                                           label="End Date"
                                           :key="index"
                                           :setId="'endDate'+index"
                                           :messages="opts.endDateMessages"
                                           :disabled="supervisor.id != null"
                            />
                        </b-col>
                        <b-col cols="2" class="d-flex align-items-center" v-if="supervisor.id != null && !isPastStartDate(supervisor.workDate.startDate)">
                            <button class="btn btn-warning" @click="showChangeModal(supervisor, index)">
                                Update Work Date
                            </button>
                        </b-col>
                        <b-col cols="2" class="d-flex align-items-center" v-if="supervisor.id == null || !isPastStartDate(supervisor.workDate.startDate)">
                            <button class="btn btn-danger" @click="(supervisor.id == null && supervisor.updatedId == null)
                            ? removeWorkPeriod(index) : showTerminateModal(supervisor, index)">
                                Remove Work Date
                            </button>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" lg="4">
                            <BaseTextInput v-model="supervisor.licenseNbr"
                                           :v="$v.workDatesApplication.mnSupervisor.$each[index].licenseNbr"
                                           slug="licenseNbr"
                                           label="Sponsor's Minnesota license number"
                                           :key="index"
                                           :setId="'supLicNbr'+index"
                                           :plaintext="supervisor.id != null"
                                           @input="setName(supervisor.licenseNbr, index)"
                            />
                        </b-col>

                        <b-col cols="12" lg="4">
                            <BaseTextInput v-model="supervisor.name"
                                           :v="$v.workDatesApplication.mnSupervisor.$each[index].name"
                                           slug="name"
                                           label="Name of Minnesota licensed Sponsor"
                                           :key="index"
                                           :setId="'supName'+index"
                                           :plaintext="true"
                            />
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" lg="4">
                            <BaseTextInput v-model="supervisor.establishment.supervisedEstName"
                                           :v="$v.workDatesApplication.mnSupervisor.$each[index].establishment.supervisedEstName"
                                           slug="supervisedEstName"
                                           label="Establishment Name"
                                           :setId="'supervisedEstName'+index"
                                           :plaintext="supervisor.id != null"
                            />
                        </b-col>
                        <b-col cols="12" lg="4">
                            <BaseMaskedTextInput v-model="supervisor.establishment.supervisedEstPhoneNumber"
                                                 :v="$v.workDatesApplication.mnSupervisor.$each[index].establishment.supervisedEstPhoneNumber"
                                                 slug="supervisedEstPhoneNumber"
                                                 label="Establishment Phone Number"
                                                 :setId="'supervisedEstPhoneNumber'+index"
                                                 mask="(###)###-####"
                                                 :plaintext="supervisor.id != null"
                            />
                        </b-col>
                        <b-col cols="12" lg="4">
                            <BaseTextInput v-model="supervisor.establishment.supervisedEstWebsite"
                                           :v="$v.workDatesApplication.mnSupervisor.$each[index].establishment.supervisedEstWebsite"
                                           slug="supervisedEstWebsite"
                                           label="Establishment Website"
                                           :setId="'supervisedEstWebsite'+index"
                                           :plaintext="supervisor.id != null"
                            />
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" lg="12">
                            <BaseTextInput v-model="supervisor.establishment.supervisedEstFullAddress"
                                           :v="$v.workDatesApplication.mnSupervisor.$each[index].establishment.supervisedEstFullAddress"
                                           slug="supervisedEstFullAddress"
                                           label="Establishment Address"
                                           tip="Please include street address, city, state, postal code, and country"
                                           :setId="'supervisedEstFullAddress'+index"
                                           :plaintext="supervisor.id != null"
                            />
                        </b-col>
                    </b-row>
                    <div>
                        <b-row v-for="(hrs, idx) in supervisor.establishment.establishmentHours" :key="hrs.id">
                            <b-col cols="6">
                                <form-group label="Establishment Days" :validator="$v.workDatesApplication.mnSupervisor.$each[index].establishment.establishmentHours.$each[idx].days">
                                    <b-form-checkbox-group
                                            :id="'days'+index+'-'+idx"
                                            v-model="hrs.days"
                                            :options="opts.dayTypeOptions"
                                            :disabled="supervisor.id != null"
                                    ></b-form-checkbox-group>
                                </form-group>
                            </b-col>
                            <b-col cols="4">
                                <BaseTextInput v-model="hrs.hours"
                                               :v="$v.workDatesApplication.mnSupervisor.$each[index].establishment.establishmentHours.$each[idx].hours"
                                               slug="name"
                                               label="Hours"
                                               :key="idx"
                                               :setId="'hours'+index+'-'+idx"
                                               :plaintext="supervisor.id != null"
                                />
                            </b-col>

                            <b-col cols="2" class="d-flex align-items-center" v-if="supervisor.id == null">
                                <button class="btn btn-secondary" @click="removeEstHours(index, idx)">
                                    Remove Hours
                                </button>
                            </b-col>
                        </b-row>
                    </div>
                    <b-row>
                        <b-col cols="2" v-if="supervisor.id == null">
                            <button class="btn btn-secondary" @click="addEstHours(index)">
                                Add Additional Hours
                            </button>
                        </b-col>
                    </b-row>
                </div>
            </div>
        </div>

        <div class="card">
            <div class="card-header">Additional Information</div>
            <div class="card-body" v-if="!!workDatesApplication">
                <b-row>
                    <b-col>
                        <p>
                            Use this page to complete answers from previous page(s) where space was insufficient. Include
                            question number(s) with each answer. If you answered "yes" to any of the items on the
                            questionnaire page, please provide a brief statement for each yes answer. Any other pertinent
                            information can be added here as well.
                        </p>
                        <p>
                            If seeking license by reciprocity, use this space to provide contact information for your
                            current licensing agency so that we may properly follow up.
                        </p>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" lg="12">
                        <BaseParagraphInput v-model="workDatesApplication.additionalInformation"
                            :v="$v.workDatesApplication.additionalInformation"
                            slug="additionalInformation"
                            label="Additional Information"
                            setId="addlInfo"
                        />
                    </b-col>
                </b-row>
            </div>
        </div>
        <b-modal id="terminate-modal" hide-header hide-footer>
            <div v-if="!!opts.selected">
                <h2>Remove Work Date(s)</h2>
                <hr/>
                <form ref="form" @submit.prevent="removeWorkPeriod(opts.selected.index)">
                    You are about to remove the work date(s) {{opts.selected.workDate.startDate}} - {{opts.selected.workDate.endDate}}, with sponsor
                    {{opts.selected.name}}, at establishment {{opts.selected.establishment.supervisedEstName}}.
                    Please provide the reason for this removal.
                    <BaseParagraphInput v-model="opts.reason"
                                        :v="$v.opts.reason"
                                        slug="reason"
                                        label="Removal Reason"
                                        setId="terminate-modal-id"/>
                    <p class="mt-2">Press Confirm to remove or Cancel to return to your application.</p>
                    <div>
                        <b-button @click="closeTerminateModal" style="margin-right:15px;" variant="secondary">Cancel</b-button>
                        <b-button type="submit" variant="primary">Confirm</b-button>
                    </div>
                </form>
            </div>
        </b-modal>
        <b-modal id="change-modal" hide-header hide-footer>
            <div v-if="!!opts.selected">
                <h2>Update Work Date(s)</h2>
                <hr/>
                <form ref="form" @submit.prevent="updateWorkPeriod(opts.selected.index)">
                    You are about to update the work date(s) {{opts.selected.workDate.startDate}} - {{opts.selected.workDate.endDate}}, with sponsor
                    {{opts.selected.name}}, at establishment {{opts.selected.establishment.supervisedEstName}}.
                    Please provide the reason for this change.
                    <BaseParagraphInput v-model="opts.reason"
                                        :v="$v.opts.reason"
                                        slug="reason"
                                        label="Update Reason"
                                        setId="change-modal-id"/>
                    <p class="mt-2">Press Confirm to remove or Cancel to return to your dashboard.</p>
                    <div>
                        <b-button @click="closeChangeModal" style="margin-right:15px;" variant="secondary">Cancel</b-button>
                        <b-button type="submit" variant="primary">Confirm</b-button>
                    </div>
                </form>
            </div>
        </b-modal>
    </div>
</template>
<script>
    import BaseParagraphInput from '@/components/templates/input/BaseParagraphInput.vue'
    import BaseTextInput from '@/components/templates/input/BaseTextInput.vue'
    import BaseMaskedTextInput from "../templates/input/BaseMaskedTextInput"
    import { required, requiredIf, minLength, maxLength } from 'vuelidate/lib/validators'
    import minDate from '@/validators/minDate'
    import maxDate from '@/validators/maxDate'
    import license from '@/validators/license'
    import moment from 'moment'
    import { dateAndYearMixin } from '@/mixins/dateAndYear.js'
    import axios from 'axios'
    import axiosRetry from 'axios-retry'

    axiosRetry(axios, { retries: 3,
        retryDelay: axiosRetry.exponentialDelay  })

    export default {
        data: () => {
            return {
                opts: {
                    startDateMessages: {
                        minDate: 'Start Date must be in the future.'
                    },
                    endDateMessages: {
                        minDate: 'End Date must be after Start Date',
                        startDefined: 'Start Date must be entered'
                    },
                    workDates: [],
                    oldDates: [],
                    dayTypeOptions: [],
                    reason: null,
                    selected: null,
                    minLengthError: false
                },
            }
        },

        props: {
            workDatesApplication: {
                type: Object,
                default () {
                    return {
                        additionalInformation: null,
                        mnSupervisor: [{
                            id: null,
                            name: null,
                            licenseNbr: null,
                            workDate: {
                                id: null,
                                startDate: '',
                                endDate: '',
                            },
                            establishment: {
                                establishmentId: null,
                                supervisedEstName: null,
                                supervisedEstFullAddress: null,
                                supervisedEstWebsite: null,
                                supervisedEstPhoneNumber: null,
                                establishmentHours: [{
                                    id: null,
                                    hours: null,
                                    days: []
                                }],
                            }
                        }],
                    }
                }
            }
        },

        components: {
            BaseParagraphInput,
            BaseTextInput,
            BaseMaskedTextInput,
        },

        mixins: [
            dateAndYearMixin
        ],

        computed: {
        },

        validations() {
            return {
                workDatesApplication: {
                    additionalInformation: {required: false},
                    mnSupervisor: {
                        required,
                        minLength: minLength(1),
                        $each: {
                            name: {required},
                            licenseNbr: {
                                required,
                                minLength: minLength(6),
                                maxLength: maxLength(6),
                                license: license(this.workDatesApplication.license ? this.workDatesApplication.license.licenseType : null)
                            },
                            workDate: {
                                startDate: {
                                    required,
                                    minDate: minDate(new Date()),
                                },
                                endDate: {
                                    required,
                                    minDate: minDate(">"),
                                },
                            },
                            establishment: {
                                supervisedEstName: {required},
                                supervisedEstFullAddress: {required},
                                supervisedEstWebsite: {required: false, maxLength: maxLength(75)},
                                supervisedEstPhoneNumber: {required, minLength: minLength(13)},
                                establishmentHours: {
                                    required,
                                    $each: {
                                        hours: {
                                            required: requiredIf((object) => {
                                                return !object.days.every(d => d === 'APT')
                                            })
                                        },
                                        days: {
                                            required,
                                            minLength: minLength(1)
                                        }
                                    }
                                },
                            },
                        }
                    },
                },
                opts: {
                    reason: { required },
                },
                form: [ 'workDatesApplication.additionalInformation' ],
                guestForm: [ 'workDatesApplication.mnSupervisor' ],
                reasonForm: [ 'opts.reason']
            }
        },

        methods: {
            showTerminateModal(item, index) {
                this.$bvModal.show('terminate-modal')
                this.opts.selected = item
                this.opts.selected.index = index
            },
            closeTerminateModal() {
                this.opts.selected = null
                this.opts.reason = null
                this.$bvModal.hide('terminate-modal')
            },
            showChangeModal(item, index) {
                this.$bvModal.show('change-modal')
                this.opts.selected = item
                this.opts.selected.index = index
            },
            closeChangeModal() {
                this.opts.selected = null
                this.opts.reason = null
                this.$bvModal.hide('change-modal')
            },

            validate() {
                this.$v.form.$touch()
                var isValid
                if(this.validateDates(this.workDatesApplication.mnSupervisor, this.workDatesApplication)
                    && this.validateYear(this.workDatesApplication.mnSupervisor)) {
                    this.opts.oldDates = this.workDatesApplication.mnSupervisor.filter(w => w.id != null)
                    this.workDatesApplication.mnSupervisor = this.workDatesApplication.mnSupervisor.filter(w => w.id == null)
                    this.workDatesApplication.mnSupervisor.splice()
                    if (this.workDatesApplication.mnSupervisor.length > 0) {
                        this.$v.guestForm.$touch()
                        isValid = !this.$v.form.$invalid && !this.$v.guestForm.$invalid
                    } else {
                        if(this.workDatesApplication.prevMnSupervisor.filter(s => s.updatedId != null).length === 0) {
                            isValid = false
                            this.opts.minLengthError = true
                        } else {
                            isValid = true
                        }
                    }
                    this.workDatesApplication.mnSupervisor = this.workDatesApplication.mnSupervisor.concat(this.opts.oldDates)
                    this.$emit('on-validate', this.$data, isValid)
                    return isValid
                }
                else {
                    isValid = false
                    this.$emit('on-validate', this.$data, isValid)
                    return isValid
                }
            },

            isPastStartDate(start) {
                return moment(start).isBefore(moment())
            },

            loadDayTypes() {
                axios.get(`${process.env.VUE_APP_API_BASE_URL}/application/public/dayTypes`, { ignoreHeader: true })
                    .then(response => {
                        for (let type of response.data) {
                            this.opts.dayTypeOptions.push({
                                value: type.code,
                                text: type.description
                            })
                        }
                    })
            },

            addEstHours: function (i) {
                this.workDatesApplication.mnSupervisor[i].establishment.establishmentHours.push({
                    id: null,
                    hours: null,
                    days: []
                })
                this.workDatesApplication.mnSupervisor.splice()
            },
            removeEstHours: function (i, i2) {
                this.$delete(this.workDatesApplication.mnSupervisor[i].establishment.establishmentHours,i2)
                this.workDatesApplication.mnSupervisor.splice()
            },

            addWorkPeriod() {
                this.workDatesApplication.mnSupervisor.splice(0,0,{
                    id: null,
                    name: null,
                    licenseNbr: null,
                    workDate: {
                        id: null,
                        startDate: '',
                        endDate: '',
                    },
                    establishment: {
                        establishmentId: null,
                        supervisedEstName: null,
                        supervisedEstFullAddress: null,
                        supervisedEstWebsite: null,
                        supervisedEstPhoneNumber: null,
                        establishmentHours: [{
                            id: null,
                            hours: null,
                            days: []
                        }],
                    }
                })
            },

            updateWorkPeriod: function (i) {
                this.$v.reasonForm.$touch()
                if (!this.$v.reasonForm.$invalid) {
                    var pd = JSON.parse(JSON.stringify(this.workDatesApplication.mnSupervisor[i]))
                    pd.changeDate =  moment().format('YYYY-MM-DD')
                    pd.changeReason = this.opts.reason
                    this.resetReason()
                    this.workDatesApplication.prevMnSupervisor.push(pd)
                    var change = JSON.parse(JSON.stringify(this.workDatesApplication.mnSupervisor[i]))
                    this.workDatesApplication.mnSupervisor[i] = {
                        id: null,
                        name: change.name,
                        licenseNbr: change.licenseNbr,
                        establishment: change.establishment,
                        workDate: change.workDate,
                        updatedId: change.id
                    }
                    this.workDatesApplication.mnSupervisor.splice()
                    this.closeChangeModal()
                }
            },
            removeWorkPeriod: function (i) {
                if (this.workDatesApplication.mnSupervisor[i].id == null && !this.workDatesApplication.mnSupervisor[i].updatedId) {
                    this.$delete(this.workDatesApplication.mnSupervisor, i)
                } else {
                    this.$v.reasonForm.$touch()
                    if (!this.$v.reasonForm.$invalid) {
                        if (this.workDatesApplication.mnSupervisor[i].id == null) {
                            var filter = this.workDatesApplication.prevMnSupervisor.filter(sup => sup.id === this.workDatesApplication.mnSupervisor[i].updatedId)
                            if (filter.length > 0) {
                                var old = filter[0]
                                old.changeDate = null
                                old.changeReason = null
                                old.terminatedDate =  moment().format('YYYY-MM-DD')
                                old.terminatedReason = this.opts.reason
                            }
                            this.resetReason()
                            this.$delete(this.workDatesApplication.mnSupervisor, i)
                            this.closeTerminateModal()
                        } else {
                            var pd = JSON.parse(JSON.stringify(this.workDatesApplication.mnSupervisor[i]))
                            pd.terminatedDate =  moment().format('YYYY-MM-DD')
                            pd.terminatedReason = this.opts.reason
                            pd.updatedId = pd.id
                            this.resetReason()
                            this.workDatesApplication.prevMnSupervisor.push(pd)
                            this.$delete(this.workDatesApplication.mnSupervisor, i)
                            this.closeTerminateModal()
                        }
                    }
                }
            },

            setName(licenseNbr, index) {
                if (licenseNbr && licenseNbr.length === 6) {
                    let payload = {
                        number: licenseNbr,
                        licenseType: this.workDatesApplication.license.licenseType
                    }
                    axios.post(`${process.env.VUE_APP_API_BASE_URL}/license/validate/license`, payload)
                        .then(response => {
                            if (response.data.status) {
                                this.workDatesApplication.mnSupervisor[index].name = response.data.fullName
                            } else {
                                this.workDatesApplication.mnSupervisor[index].name = null
                            }
                            this.workDatesApplication.mnSupervisor.splice()
                        })
                } else {
                    this.workDatesApplication.mnSupervisor[index].name = null
                    this.workDatesApplication.mnSupervisor.splice()
                }
            },
            resetReason() {
                this.opts.reason = null
            }
        },

        mounted() {
            this.loadDayTypes()
        },

        watch: {
            workDatesApplication() {
                for (var prop in this.workDatesApplication) {
                    if (this.hasOwnProperty(prop) && this.workDatesApplication[prop] != null) {
                        this[prop] = this.workDatesApplication[prop]
                    }
                }

                if (this.workDatesApplication.mnSupervisor) {
                    this.workDatesApplication.mnSupervisor.forEach((sup, idx) => {
                        if(sup.workDate === null) {
                            sup.workDate = {
                                id: null,
                                startDate: '',
                                endDate: '',
                            }
                        }
                        if (sup.establishment.establishmentHours === null ) {
                            sup.establishment.establishmentHours =
                                [{
                                    id: null,
                                    hours: null,
                                    days: []
                                }]
                        } else {
                            sup.establishment.establishmentHours.forEach((hrs) => {
                                if (hrs.days.some(d => d.code != undefined)) {
                                    hrs.days = hrs.days.map(d => d.code)
                                }
                            })
                        }
                    })
                }
                if (this.workDatesApplication.prevMnSupervisor) {
                    this.workDatesApplication.prevMnSupervisor.forEach((sup, idx) => {
                        sup.establishment.establishmentHours.forEach((hrs) => {
                            if (hrs.days.some(d => d.code != undefined)) {
                                hrs.days = hrs.days.map(d => d.code)
                            }
                        })
                    })
                }
                this.additionalInfo = this.workDatesApplication.additionalInfo
            }
        }
    }
</script>